<template>
  <v-container fluid class="edit-role-page">
    <div class="pa-2  fill-height d-flex flex-column justify-start align-start">
      <v-row
        v-if="loading"
        no-gutters
        align="center"
        justify="center"
        class="fill-width"
      >
        <v-progress-circular
          :size="60"
          :width="5"
          color="primary"
          indeterminate
        />
      </v-row>
      <div
        v-else
        class="fill-width fill-height d-flex justify-space-between align-center align-content-start flex-wrap"
      >
        <div class="d-flex justify-space-between align-center fill-width">
          <v-card elevation="0" color="gray1" width="400px">
            <v-card-text class="font-semiBold-16 text-center">{{
              roleName
            }}</v-card-text>
          </v-card>
          <v-btn
            color="primary"
            depressed
            :loading="loading"
            class="py-6 ms-2"
            @click="createNewRole"
            >{{
              $t(
                "panel.adminManagement.rolesPage.editActionsPage.editActionsBtn"
              )
            }}</v-btn
          >
        </div>
        <v-row
          no-gutters
          align="center"
          justify="start"
          align-content="start"
          class="checkBoxes fill-width overflow-auto"
        >
          <v-col
            v-for="(action, index) in userActions"
            :key="index"
            sm="6"
            md="4"
            lg="3"
            class="py-0"
          >
            <div>
              <v-checkbox
                v-model="action.selected"
                :label="action.name"
                dense
                hide-details
                class="checkbox pa-2 text-truncate mt-2"
              />
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import { userInfoService } from "@/services";

export default {
  name: "edit-role",
  props: ["roleName"],
  data() {
    return {
      loading: false,
      userActions: []
    };
  },
  mounted() {
    this.getUserActions();
  },
  methods: {
    createNewRole() {
      this.loading = true;
      let actionIds = [];
      this.userActions.map(item => {
        if (item.selected) {
          actionIds.push(item.id);
        }
      });
      userInfoService
        .createNewRole({ actionIds, roleTitle: this.roleName })
        .then(() => {
          this.$toast.success(
            this.$t(
              "panel.adminManagement.rolesPage.editActionsPage.successMsgToast"
            )
          );
          this.$router.replace({ name: "roles" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getUserActions() {
      this.loading = true;
      userInfoService
        .getRoleActions(this.roleName)
        .then(response => {
          this.userActions = response.data.data.actions;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
@import "Edit";
</style>
